import axios from "axios";
import { BASE_APIURL } from "../helpers/url";


const createStudentCandidate = async (data) => {
  const response = await axios.post(`${BASE_APIURL}/v1/student-candidate/`, data);
  return response.data;
};

export { createStudentCandidate };
